import { Box } from 'components'

const OnboardingAssignmentEdit = () => {
 return (<Box>OnboardingAssignmentEdit</Box>)
}

export default OnboardingAssignmentEdit;
